import { render, staticRenderFns } from "./ac1.vue?vue&type=template&id=225c4d02&scoped=true&"
import script from "./ac1.vue?vue&type=script&lang=js&"
export * from "./ac1.vue?vue&type=script&lang=js&"
import style0 from "./ac1.vue?vue&type=style&index=0&id=225c4d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c4d02",
  null
  
)

export default component.exports